import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Toast from '@/components/ToastMessage/toast'

/** 导入插件 */
import './plugins/element.js'
import './servers/request'
import './common/layout.css'

import vueSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

// element 提示
import './mixins/tool.js';

import VueCountdown from '@chenfengyuan/vue-countdown';

Vue.component(VueCountdown.name, VueCountdown);

Vue.use(vueSwiper)

Vue.prototype.$Toast = Toast.install;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
